import React, { useEffect, useState } from 'react';
import Button from '@amzn/awsui-components-react/polaris/button';
import { useTranslation } from 'react-i18next';

// Show button after scrolling past ~2 event cards worth of content
const SCROLL_THRESHOLD = 500;

export function ScrollToTopButton() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > SCROLL_THRESHOLD);
    };
    // passive: true avoids blocking scroll performance (never calls preventDefault)
    window.addEventListener('scroll', handleScroll, { passive: true });
    // Sync initial state: the handler only runs on scroll events, so a page that loads already
    // scrolled past the threshold (refresh mid-page, bfcache restore, in-page anchor) would
    // otherwise keep the button hidden until the user scrolled again.
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        zIndex: 1000,
        // visibility (not just opacity) is what removes the hidden button from the tab order
        // and the accessibility tree; pointerEvents only blocks the mouse, so without this a
        // keyboard user could Tab to an invisible control. visibility is intentionally NOT
        // transitioned: CSS keeps it `visible` for the whole transition on the way out, which
        // would leave the button focusable/announced during the fade. Toggling it discretely
        // removes the control from the a11y tree immediately when hidden; only opacity fades.
        transition: 'opacity 0.3s ease-in-out',
        opacity: visible ? 1 : 0,
        visibility: visible ? 'visible' : 'hidden',
        pointerEvents: visible ? 'auto' : 'none',
      }}
    >
      <Button
        iconName="angle-up"
        variant="normal"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        ariaLabel={t('scrollToTop.ariaLabel')}
      />
    </div>
  );
}
